import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "upgradeModalKey"];
import { useUpgradeModal } from 'ui-addon-upgrades/ums/useUpgradeModal';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
export const EmbeddedUpgradeButton = _ref => {
  let {
      children,
      upgradeModalKey
    } = _ref,
    styledButtonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    openUpgradeModal
  } = useUpgradeModal(upgradeModalKey);
  return /*#__PURE__*/_jsx(Button, Object.assign({}, styledButtonProps, {
    onClick: openUpgradeModal,
    children: children
  }));
};
export default EmbeddedUpgradeButton;